import {post} from '../utils/request'

export default {
    getAll: function (query, paginate) {
        return post("/admin/deviceStandard/list", {...query, ...paginate});
    },
    findById: function (id) {
        return post("/admin/deviceStandard/show", {id});
    },
    create: function (device) {
        return post("/admin/deviceStandard/create", device);
    },
    update: function (device) {
        return post("/admin/deviceStandard/update", device);
    },

    deleteById: function (id) {
        return post("/admin/deviceStandard/delete", {id});
    },
    getByEpId: function (epId) {
        return post("/admin/deviceStandard/getByEpId", {epId});
    },
    findByEpAndType: function (epId, deviceTypeId) {
        return post("/admin/deviceStandard/findByEpAndType", {epId, deviceTypeId});
    },
    recharge: function (epId, deviceTypeId, amount) {
        return post("/admin/deviceStandard/recharge", {epId, deviceTypeId, amount});
    }
}
